import React from "react"
import { Button, makeStyles } from "@material-ui/core"
import { GET_LATEST_FILES_SORT } from "../../../utils"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	active: {
		color: theme.palette.common.white,
		//border: `1px solid ${theme.palette.primary.dark}`,
	},
	inActive: {
		color: theme.palette.primary.dark,
		border: `1px solid ${theme.palette.primary.dark}`,
	},
}))

const GetLatestFiles = ({ onClickHandler, isDisabled = false }) => {
	const classes = useStyles()
	const [t] = useTranslation("global")

	return (
		<>
			<Button
				variant="outlined"
				size="small"
				onClick={() => onClickHandler(GET_LATEST_FILES_SORT)}
				className={classes.inActive}
				style={{
					textTransform: "initial",
				}}
				disabled={isDisabled}
			>
				{t("dropZone.getLatestFiles")}
			</Button>
		</>
	)
}

export default GetLatestFiles
